import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Lock, Sparkles } from "lucide-react";
import { ASSETS } from "../lib/assets";
import { Overline, Reveal } from "../components/Section";

export default function SalaryAI() {
  return (
    <div data-testid="salaryai-page" className="bg-white text-slate-900">
      <section className="relative min-h-[92vh] flex items-center overflow-hidden bg-gradient-to-br from-blue-50 via-white to-emerald-50">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute -top-40 -right-40 h-[500px] w-[500px] rounded-full bg-blue-400/30 blur-[120px]" />
          <div className="absolute -bottom-40 -left-40 h-[500px] w-[500px] rounded-full bg-emerald-400/25 blur-[120px]" />
        </div>

        <div className="relative max-w-5xl mx-auto px-6 md:px-10 py-32 w-full text-center">
          <Reveal>
            <Link
              to="/products"
              data-testid="salaryai-back-products"
              className="inline-flex items-center gap-2 text-xs text-slate-500 hover:text-slate-900"
            >
              ← Back to products
            </Link>
          </Reveal>

          <Reveal delay={0.1}>
            <motion.div
              initial={{ scale: 0.85, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="mt-10 mx-auto h-36 w-36 rounded-3xl shadow-2xl ring-1 ring-blue-200 overflow-hidden bg-white grid place-items-center p-3"
            >
              <img src={ASSETS.logos.salaryai} alt="SalaryAI" className="h-full w-full object-contain" />
            </motion.div>
          </Reveal>

          <Reveal delay={0.2}>
            <Overline color="text-blue-700" className="mt-10">A PJSRS Infotech Private Limited Product</Overline>
          </Reveal>

          <Reveal delay={0.25}>
            <h1 className="mt-4 font-display font-black text-[clamp(2.75rem,7vw,5.5rem)] leading-[0.95] tracking-tighter">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-700 via-blue-500 to-emerald-500">SalaryAI</span>
            </h1>
          </Reveal>

          <Reveal delay={0.3}>
            <p className="mt-6 font-display text-lg md:text-2xl font-bold text-slate-700 max-w-3xl mx-auto">
              Know Your Salary. Understand Your Tax. Secure Your Career.
            </p>
          </Reveal>

          <Reveal delay={0.4}>
            <div className="mt-12 inline-flex items-center gap-3 rounded-full bg-blue-500/10 border border-blue-500/30 px-5 py-3 text-sm text-blue-800 font-medium">
              <Lock className="h-4 w-4" />
              Product details coming soon
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full rounded-full bg-blue-500 opacity-75 animate-ping" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500" />
              </span>
            </div>
          </Reveal>

          <Reveal delay={0.5}>
            <p className="mt-8 max-w-xl mx-auto text-slate-500">
              We&apos;re building something powerful for employees, HR professionals, and organisations.
              For partnership enquiries, early access requests or press, get in touch with our team.
            </p>
          </Reveal>

          <Reveal delay={0.55}>
            <div className="mt-10 flex flex-wrap justify-center gap-3">
              <Link
                to="/contact"
                data-testid="salaryai-cta-contact"
                className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-blue-700 to-emerald-500 text-white px-7 py-4 text-sm font-bold hover:opacity-90 transition shadow-[0_10px_40px_rgba(29,78,216,0.35)] hover:-translate-y-0.5"
              >
                Get in touch <ArrowUpRight className="h-4 w-4" />
              </Link>
              <Link
                to="/products"
                data-testid="salaryai-link-products"
                className="inline-flex items-center gap-2 rounded-full border border-slate-300 px-7 py-4 text-sm font-medium hover:bg-slate-50 transition"
              >
                <Sparkles className="h-4 w-4" /> Explore other products
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
